import { Star } from "lucide-react";

const ReviewsSection = ({ reviews }) => {
  return (
    <section 
      className="py-20 md:py-28 bg-nukleus-card"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-nukleus-lilac mb-4 block">
            Customer Reviews
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight mb-4">
            What People Are Saying
          </h2>
          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-white font-semibold">4.9</span>
            <span className="text-white/50">from 2,400+ reviews</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={review.id}
              className="bg-nukleus-bg rounded-2xl p-6 md:p-8 border border-white/5 card-hover transition-all duration-300"
              data-testid={`review-${index}`}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star 
                    key={i} 
                    className={`w-4 h-4 ${
                      i < review.rating 
                        ? "fill-yellow-400 text-yellow-400" 
                        : "text-white/20"
                    }`} 
                  />
                ))}
              </div>
              
              {/* Content */}
              <p className="text-white/70 leading-relaxed mb-6">
                "{review.content}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-nukleus-violet/20 flex items-center justify-center">
                  <span className="text-nukleus-violet font-semibold">
                    {review.avatar_initial}
                  </span>
                </div>
                <div>
                  <p className="text-white font-medium">{review.author}</p>
                  <p className="text-white/50 text-sm">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
